import React, { Component } from "react";
import { Input } from "reactstrap";

class FacilityList extends Component {
  render() {
    console.log("this.props.facilityFillData", this.props.facilityFillData);
    return (
      <Input type="select" name="drpFac" id="drpFac" value={this.props.facilityValue} onChange={this.props.drpChangeFac}>
        <option value="">--Select Facility--</option>
        {this.props.facilityFillData.map((item, i) => (
          <option key={item.facility_id} value={item.facility_id}>
            {item.facility_name}
          </option>
        ))}
      </Input>
    );
  }
}
FacilityList.defaultProps = {
  facilityFillData: [],
  facilityValue: "",
};

export default FacilityList;



// WEBPACK FOOTER //
// ./src/shared/components/facility_list/index.js